import {Progress} from 'antd'
import React from 'react'
import StylesType from '@/types/StylesType';

import './index.less'

declare const ProgressTypes: ["line", "circle", "dashboard"];
declare type ProgressType = (typeof ProgressTypes)[number];

declare const ProgressStatus: ["success", "exception", "normal", "active"];
declare type ProgressStatu = (typeof ProgressStatus)[number];


interface propsType {
  type?: ProgressType;
  format?: () => {};
  percent?: number;
  showInfo?: boolean;
  status?: ProgressStatu;
  strokeColor?: string;
  successPercent?: number;
  strokeWidth?: number
}

const Progr: React.FC<propsType&StylesType> = props => {
  return (
    <>
      <Progress
        {...props}
      ></Progress>
    </>
  )
}

export default Progr
